import { useSyncExternalStore } from 'react';

/**
 * 0.63 „Mehrere Aufgaben auf einmal“: Dialog „Aufgaben importieren …“ öffnen – aus dem Projektmenü, dem Listen- und
 * Spaltenmenü, der Befehlspalette und der Rückfrage nach dem Einfügen. Klein und im Startpaket; der Dialog selbst
 * wird erst beim Öffnen geladen.
 */
export interface TaskImportTarget {
  projectId: string;
  listId?: string;
  statusId?: string;
  sectionId?: string;
  /** vorbelegter Text (aus dem Aufgabenfeld) */
  text?: string;
}

let current: TaskImportTarget | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function openTaskImport(target: TaskImportTarget) {
  current = target;
  emit();
}

export function closeTaskImport() {
  current = null;
  emit();
}

export function useTaskImport(): TaskImportTarget | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}

/** Mehrere Aufgaben im Text? Billige Prüfung beim Einfügen – das Zerlegen lädt erst die Rückfrage */
export const maybeSeveral = (text: string) => text.includes('\t') || text.split(/\r?\n/).filter((l) => l.trim()).length >= 2;
